import * as React from 'react';
import * as ReactDOM from 'react-dom'; //let container: Element | null = null

export var Portal = function Portal(_a) {
  var children = _a.children;
  return ReactDOM.createPortal(React.createElement("div", null, React.createElement("div", null, children)), document.body); // All stuff that are below is for return the portal with the follow structure:
  // --------------------------------
  // <div>
  //  <div>
  //    {children}
  //  </div>
  // </div>
  // --------------------------------
  // So it seems a bit unnecessary to me, as there are no set styles 
  // or any reason why it would be returned in this way. 
  //
  // However, if we need to leave the structure that Sancho UI has planned here, 
  // we can return it via JSX. But if it's not too much of a problem,
  // we can just return the children:
  // return ReactDOM.createPortal(children, document.body)
  // Stuff:
  // const [target] = React.useState<HTMLDivElement | null>(() => {
  //   This is tricky to test, as I found no way to mock the document with undefined value.
  //   if (typeof document === 'undefined') {
  //     return null
  //   }
  //   if (!container) {
  //     container = document.createElement('div')
  //     document.body.appendChild(container)
  //   }
  //   const div = document.createElement('div')
  //   container.appendChild(div)
  //   return div
  // })
  // React.useEffect(() => {
  //   return () => {
  //     if (target) {
  //       container!.removeChild(target)
  //     }
  //   }
  // }, [target])
  // return target ? ReactDOM.createPortal(children, target) : null
};